import React from 'react'

import ImageContent from '../Helper/ImageContent'

const styles = {
    mainWrapper: "grid grid-cols-1 lg:grid-cols-2 sm:w-full",
    leftWrapper: "flex justify-start items-center",
    imgStyle: "h-full w-full px-2 sm:px-0 sm:h-5/6 sm:w-11/12 xl:w-10/12 2xl:h-4/6 2xl:w-9/12 rounded-lg",
    rightWrapper: "flex justify-end items-start md:items-center lg:items-start flex-col text-[#333333]",
    rightContainer: "flex flex-col justify-center items-start sm:items-center 2xl:text-lg",
    leftContainer: "flex flex-col justify-start items-start",
    textContainer: "flex items-center sm:centerContent text-sm sm:text-md",
};

const OurWork = ({projectDetails}) => {
  return (
    <div className="text-[#333333]">
        <h2 className="font-bold text-2xl">Our Work</h2>
        
        <div className={styles.mainWrapper}>
            {/* Left Side */}
            <div className={styles.rightWrapper.concat(" md:mr-6")}>
                <div className={styles.rightContainer}>
                    <div className={styles.textContainer.concat(" mt-5")}>
                        <p className="text-[#333333]/70">{projectDetails.ourWorkPara1}</p>
                    </div>
                    <div className={styles.leftWrapper}>
                        <div className="mt-6">
                            <img src={projectDetails?.images?.image1} alt="Who we are" className={styles.imgStyle} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Side */}
            <div className={styles.rightWrapper.concat(" lg:ml-6")}>
                <div className={styles.rightContainer}>
                    <div className={styles.textContainer.concat(" mt-5")}>
                        <p className="text-[#333333]/70">{projectDetails.ourWorkPara2}</p>
                    </div>
                    <div className={styles.leftWrapper}>
                        <div className="mt-6">
                            <img src={projectDetails?.images?.image2} alt="Who we are" className={styles.imgStyle} />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section className="mt-32">
            <ImageContent mainSection={projectDetails?.images?.detailImage1} PARAGRPH_1={projectDetails?.detailText1}  order_1={1}/>
            <ImageContent mainSection={projectDetails?.images?.detailImage2} PARAGRPH_1={projectDetails?.detailText2}  order_1={2}/>
        </section>

        <section className="mt-26 w-full centerContent">
            <img src={projectDetails?.images?.mainImage} alt="" />
        </section>
        
    </div>
  )
}

export default OurWork